"use client";

import React from "react";
import "katex/dist/katex.min.css";
import katex from "katex";
import styles from "./index.module.css";
import { GeneralPropsType } from "@/common/types";
interface KatexComponentProps extends GeneralPropsType {
  mathExpression: string;
  displayMode?: boolean;
}
const KatexComponent: React.FC<KatexComponentProps> = ({
  mathExpression,
  displayMode = true,
  className,
  onClick
}) => {
  let html = "";
  try {
    html = katex.renderToString(mathExpression, {
      throwOnError: false,
      displayMode: displayMode
    });
  } catch (error) {
    console.error("Error rendering KaTeX expression: ", error);
  }
  return <div className={`${styles.katexContainer} ${className || " "}`} onClick={onClick} dangerouslySetInnerHTML={{
    __html: html
  }} data-sentry-component="KatexComponent" data-sentry-source-file="index.tsx" />;
};
export default KatexComponent;